export const calculateHeight = () => {
  if (window.matchMedia("(min-width: 1707px)").matches) {
    return 716;
  } else if (window.matchMedia("(min-width: 1501px)").matches && window.matchMedia("(max-width: 1706px)").matches) {
    return 575;
  } else if (window.matchMedia("(min-width: 1408px)").matches && window.matchMedia("(max-width: 1500px)").matches) {
    return 507;
  } else if (window.matchMedia("(min-width: 1286px)").matches && window.matchMedia("(max-width: 1407px)").matches) {
    return 423;
  } else if (window.matchMedia("(min-width: 1216px)").matches && window.matchMedia("(max-width: 1281px)").matches) {
    return 392;
  } else if (window.matchMedia("(min-width: 1024px)").matches && window.matchMedia("(max-width: 1215px)").matches) {
    return 350;
  } else if (window.matchMedia("(min-width: 768px)").matches && window.matchMedia("(max-width: 1023px)").matches) {
    return 350;
  } else if (window.matchMedia("(max-width: 767px)").matches) {
    return 224;
  }
};
